// @flow
import { encode } from "html-entities";

import { IllegalArgumentException } from "../../exceptions";

type removeUnwantedHtmlOptions = {
  allowedTags?: Array<string>,
};

/**
 * Translates html entities to their correct decimal equivalent
 * When path is only one deep better use optional chaining
 */
const properEntityEncoding = (html: string) => {
  return encode(html, { mode: "nonAsciiPrintableOnly", level: "xml" });
};

/**
 * removes unwanted html, this might result in incorrect html, as it removes all html that we don't except,
 * like <b style="font-weight: 400">bold</b> will result in bold</b>
 */
const removeUnwantedHtml = (
  html: string,
  options: removeUnwantedHtmlOptions = {
    allowedTags: ["p", "br", "b", "i", "u", "strike"],
  },
): string => {
  if (typeof html !== "string") {
    throw new IllegalArgumentException("sanitizeHTML method expects a string");
  }

  const correctEntityHtml = properEntityEncoding(html);

  // remove attributes from html elements
  const htmlWithoutAttributes = correctEntityHtml.replace(
    /<(\w+)(.|[\r\n])*?>/gi,
    "<$1>",
  );

  const htmlWithCorrectBR = htmlWithoutAttributes.replace(
    /<br\s*>/gi,
    "<br />",
  );

  // remove not allowed tags
  const allowedTags = Array.isArray(options.allowedTags)
    ? options.allowedTags.join("|")
    : "";
  const pattern = `<(?!\\/?(${allowedTags})(>|\\s\\/))[^<]+?>`;
  const regex = new RegExp(pattern, "gi");

  return htmlWithCorrectBR.replace(regex, "");
};

export { removeUnwantedHtml };
